import React, { Component } from 'react';
import {Helmet} from 'react-helmet';

class Customer extends Component {

  render() {
    return (
        <div className="page customer" id="page">
          <Helmet>
            <title>rewardeclub | Customers celebrates their important days with their preferred businesses.</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
            <meta name="description" content="Customers benefits directly from their preferred businesses on rewardeclub." />
            <meta name="keywords" content="eclub, e-club, customer eclub, customer e-club, customers eclub, customers e-club, manage eclub, eclub management, manage e-club, e-club management, connect business and customers" />
            <meta name="robots" content="index, follow" />
          </Helmet>
          Customers benefits directly from their preferred businesses on <b>rewardeclub</b>.
          <p/>
          <div className="box-1">
            <div className="box-heading">How does it work for Customers?</div>
            <div className="box-body">
            1. Sign up for free<p />
            2. Optionally add your family members<p />
            3. Start receiving discount coupons on<br />
              <span className="dot">||</span>Birthdays<br />
              <span className="dot">||</span>Anniversaries and<br />
              <span className="dot">||</span>other special days<p />
            4. Additionaly, receive special discounts from your preferred businesses. 
            </div>
          </div>
        </div>
    );
  }
}

export default Customer;



// WEBPACK FOOTER //
// ./src/page/Customer.js